import { ChangeDetectionStrategy, Component, HostListener, ViewChild, inject } from "@angular/core";
import { AuditSectionTabComponent } from "./components/audit-section-tab/audit-section-tab.component";
import { ConfirmCleanDialogComponent } from "./components/confirm-clean-dialog/confirm-clean-dialog.component";
import { EquipmentSheetComponent } from "./components/equipment-sheet/equipment-sheet.component";
import { LAB_EQUIPMENT_1, LAB_EQUIPMENT_2, LAB_EQUIPMENT_3 } from "./data/lab-equipment";
import {
  LAB_TESTING_PROCEDURES_1_QUESTIONS,
  LAB_TESTING_PROCEDURES_2_QUESTIONS,
  SAMPLING_QUESTIONS,
} from "./data/lab-audit-questions";
import { LabAuditStateService } from "./services/lab-audit-state.service";
import { CementJobTabComponent } from "./tabs/cement-job-tab/cement-job-tab.component";
import { InformationTabComponent } from "./tabs/information-tab/information-tab.component";
import { SafetyTabComponent } from "./tabs/safety-tab/safety-tab.component";

type AuditTab =
  | "information"
  | "safety"
  | "cementJob"
  | "labEquipment1"
  | "labEquipment2"
  | "labEquipment3"
  | "sampling"
  | "labTestingProcedures1"
  | "labTestingProcedures2";

@Component({
  selector: "app-lab-audit-checklist",
  standalone: true,
  imports: [
    InformationTabComponent,
    SafetyTabComponent,
    CementJobTabComponent,
    AuditSectionTabComponent,
    EquipmentSheetComponent,
    ConfirmCleanDialogComponent,
  ],
  templateUrl: "./lab-audit-checklist.component.html",
  styleUrl: "./lab-audit-checklist.component.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabAuditChecklistComponent {
  @ViewChild(ConfirmCleanDialogComponent) private cleanDialog?: ConfirmCleanDialogComponent;
  activeTab: AuditTab = "information";
  printing = false;
  private documentTitleBeforePrint = "";
  readonly auditState = inject(LabAuditStateService);
  readonly labEquipment1 = LAB_EQUIPMENT_1;
  readonly labEquipment2 = LAB_EQUIPMENT_2;
  readonly labEquipment3 = LAB_EQUIPMENT_3;
  readonly samplingQuestions = SAMPLING_QUESTIONS;
  readonly labTestingProcedures1Questions = LAB_TESTING_PROCEDURES_1_QUESTIONS;
  readonly labTestingProcedures2Questions = LAB_TESTING_PROCEDURES_2_QUESTIONS;

  openCleanDialog(): void {
    this.cleanDialog?.open();
  }

  printAll(): void {
    this.documentTitleBeforePrint = document.title;
    document.title = "Lab Audit Checklist";
    document.documentElement.classList.add("lab-audit-printing");
    document.body.classList.add("lab-audit-printing");
    this.printing = true;
    requestAnimationFrame(() => requestAnimationFrame(() => window.print()));
  }

  @HostListener("window:afterprint")
  finishPrinting(): void {
    this.printing = false;
    document.documentElement.classList.remove("lab-audit-printing");
    document.body.classList.remove("lab-audit-printing");
    if (this.documentTitleBeforePrint) {
      document.title = this.documentTitleBeforePrint;
    }
  }
}
